<template>
  <CommonDrop
      v-model="currentValue"
      url="/trade/agreement/list/code"
      :autoDefault="false"
      :filterable="true"
      :remote="true"
      :valName="valName"
      labelName="code"
      :disabled="disabled"
      :clearable="true"
      :size="size"
      :placeholder="placeholder"
  ></CommonDrop>
</template>
<script>
import CommonDrop from "@/components/CommonDrop";
export default {
  components: { CommonDrop },
  name: "order-drop",
  props: {
    value: {
      type: String ,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size:{
      type:String,
      default:'mini'
    },
    placeholder:{
      type:String,
      default:''
    },
    valName:{
      type:String,
      default:'code'
    }
  },
  computed: {
    currentValue: {
      get() {
        if (this.value === null || this.value === undefined) {
          return "";
        }
        return String(this.value);
      },
      set(newVal) {
        this.$emit("input", newVal);
        this.$emit("change", newVal);
      },
    },
  },
  methods: {},
};
</script>
